import React from 'react';
import {
  Box,
  Typography,
  useTheme,
  useMediaQuery,
} from '@mui/material';

const PageLayout = ({
  title,
  subtitle,
  children,
  showTitle = true,
  titleVariant = 'h4',
  titleSx = {},
  containerSx = {},
  ...props
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box
      sx={{
        p: { xs: 2, sm: 3 },
        ...containerSx,
      }}
      {...props}
    >
      {showTitle && (
        <Box sx={{ mb: 3 }}>
          <Typography
            variant={titleVariant}
            sx={{
              fontSize: { xs: "1.2rem", sm: "1.5rem", md: "1.8rem" },
              fontWeight: 600,
              mb: 1,
              wordBreak: "break-word",
              ...titleSx,
            }}
          >
            {title}
          </Typography>
          {subtitle && (
            <Typography variant="body2" color="text.secondary">
              {subtitle}
            </Typography>
          )}
        </Box>
      )}
      {children}
    </Box>
  );
};

export default PageLayout;
